import React from 'react';
import { motion } from 'framer-motion';

// Concepto 3: Bloque de Anticipación
// Va entre Señal y Protocolo.
// Hace imaginar el destino antes de mostrar el vehículo.
// La usuaria que imagina el resultado percibe el protocolo
// como el 'cómo', no como una oferta.

export function AnticipationSection() {
  return <section className="bg-gradient-hero px-5 md:px-8" style={{
    padding: '5rem 1.25rem'
  }} data-id="element-6" data-mp="1n9sugt6t43k8">
      <div className="max-w-xl mx-auto" data-id="element-7" data-mp="2jxywd8ccghut">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="border-l-2 pl-6 md:pl-8" style={{
        borderColor: 'rgba(200,168,112,0.35)'
      }} data-id="element-8" data-mp="2k14hydlrl1ls">
          <p className="uppercase tracking-[0.2em] text-[#C8A870] mb-5" style={{
          fontSize: 11,
          fontFamily: 'sans-serif',
          fontWeight: 600
        }} data-id="element-9" data-mp="33nst80tx1n5w">
            Imaginá esto
          </p>

          <p className="font-display text-[#F0E8D8] leading-[1.45]" style={{
          fontSize: 'clamp(20px, 4.5vw, 30px)'
        }} data-id="element-10" data-mp="3cdz9pmv8d29p">
            Despertás dentro de 21 días.
          </p>

          <p className="font-display italic text-[#F0E8D8]/70 mt-4 leading-[1.5]" style={{
          fontSize: 'clamp(17px, 3.5vw, 24px)'
        }} data-id="element-11" data-mp="33kduk2f5lizr">
            Sin esa sensación de estar luchando
            contra tu propio cuerpo.
          </p>

          <p className="font-display italic text-[#F0E8D8]/70 mt-4 leading-[1.5]" style={{
          fontSize: 'clamp(17px, 3.5vw, 24px)'
        }} data-id="element-12" data-mp="2ylj3kd718o4k">
            Con una rutina que finalmente tiene sentido
            para la etapa que estás viviendo.
          </p>

          <p className="font-display text-[#C8A870] mt-6" style={{
          fontSize: 'clamp(16px, 3vw, 20px)'
        }} data-id="element-13" data-mp="2oppha23ihg9l">
            Eso es lo que construís con H·E·R.
          </p>
        </motion.div>
      </div>
    </section>;
}